import AmlQuestionnaireForm from '@/features/onboarding/aml-questionnaire/components/form';
import AmlQuestionnaireLayout from '@/features/onboarding/aml-questionnaire/layout';

const AmlQuestionnairePage = () => {
  return (
    <AmlQuestionnaireLayout>
      <AmlQuestionnaireForm />
    </AmlQuestionnaireLayout>
  );
};
AmlQuestionnairePage.displayName = 'AmlQuestionnairePage';

export default AmlQuestionnairePage;
